import home from './home'
import user from './user'
import goods from './goods'
import news from './news'
export default {
  ...home,
  ...user,
  ...goods,
  ...news
}
